/* Services, the Services page at /pages/services since the CEO approved it on 2026-10-19 (templates/page.services.json),
   after the moments kit (assets/cg-moments.js, window.CGMO). Four parts: (1) the opening, where the card of your team
   lands above the boxes and the light settles under "good hands"; (2) the launch plan, the page's one pinned moment:
   the store builds itself one step at a time on native scroll, and where the screen is too short it plays once in
   view; each step's number shows that step; (3) a week with us, the days landing one by one, each Approved once;
   (4) the proof's numbers, settling once. Everything plays once and moves only pictures. Motion follows the kit's
   state alone (CGMO.live), never the visitor's motion setting (the CEO, 2026-10-19): paused, ?still, no script or the
   theme editor, every moment is finished and still. The Pause animations button (cg:motion) switches it in place:
   paused, the timers stop and the launch plan is unpinned on its finished store; played again, what was shown stays
   finished and the launch plan pins where it fits. The closing lamp is the kit's. Words live in the sections. */
(function () {
  'use strict';
  var MO = window.CGMO;
  var PAGE = document.getElementById('pg-services');
  if (!MO || !PAGE) return;
  function all(root, sel) { return [].slice.call(root.querySelectorAll(sel)); }
  function later(fn, s) { return setTimeout(fn, s * 1000); }
  function on(els, cls) { els.forEach(function (el) { el.classList.add(cls || 'on'); }); }
  // the Pause animations button: each part answers after the kit has switched (CGMO.live is already the new state)
  function onMotion(fn) { document.addEventListener('cg:motion', fn); }

  // ---- (1) the opening: once, after the page has loaded and the main thread is free
  function opening(sec) {
    var card = sec.querySelector('.sv-land'), glow = all(sec, '.mo-gw'), timers = [];
    function finish() { timers.forEach(clearTimeout); timers = []; if (card) card.classList.add('on'); on(glow); }
    onMotion(finish);
    if (!MO.live) { finish(); return; }
    function play() {
      if (!MO.live) return;
      timers.push(later(function () { if (card) card.classList.add('on'); }, 0.15));
      timers.push(later(function () { on(glow); }, 0.9));
    }
    var go = function () { (window.requestIdleCallback || function (f) { return setTimeout(f, 120); })(play, { timeout: 900 }); };
    if (document.readyState === 'complete') go(); else addEventListener('load', go, { once: true });
  }

  // the light under a heading's few words, once its moment comes into view
  function glowIn(sec) {
    var glow = all(sec, '.mo-gw');
    if (!glow.length) return;
    onMotion(function () { on(glow); });
    if (!MO.live) { on(glow); return; }
    MO.when(sec, 0.7, function () { on(glow); });
  }

  // ---- (2) the launch plan
  function build(sec) {
    var scene = sec.querySelector('.sv-scene'), track = sec.querySelector('.sv-track'), pin = sec.querySelector('.sv-pin');
    if (!scene || !track || !pin) return;
    var parts = all(scene, '.sv-f'), beats = all(sec, '.sv-beat'), btns = all(sec, '.sv-b');
    var bar = sec.querySelector('.sv-bar'), ok = scene.querySelector('.sv-okw .mo-ok');
    var n = beats.length || 6, cur = -1, timers = [];
    function progress(p) { if (bar) bar.style.setProperty('--p', p.toFixed(3)); }
    // step b (1 to n): each part shows from its step to its last step
    function show(b) {
      if (b === cur) return;
      cur = b;
      scene.setAttribute('data-beat', String(b));
      parts.forEach(function (el) {
        var from = +el.getAttribute('data-from') || 1, to = +(el.getAttribute('data-to') || 99);
        el.classList.toggle('on', from <= b && b <= to);
      });
      if (ok) ok.classList.toggle('on', b >= 4);
      beats.forEach(function (li, i) { li.classList.toggle('on', i === b - 1); li.classList.toggle('done', i < b - 1); });
      btns.forEach(function (x, i) { x.setAttribute('aria-pressed', i === b - 1 ? 'true' : 'false'); });
    }
    function stop() { timers.forEach(clearTimeout); timers = []; }
    function finish() { stop(); cur = -1; show(n); progress(1); }

    var pinned = false, sc = null, raf = 0;
    btns.forEach(function (x, i) {
      x.addEventListener('click', function () {
        stop();
        if (pinned && sc) {
          // a number moves the page to its step, and the scroll does the rest
          var y = sc.top - MO.head() + sc.range * ((i + 0.5) / n);
          window.scrollTo({ top: Math.round(y), behavior: 'smooth' });
          return;
        }
        show(i + 1); progress((i + 1) / n);
      });
    });

    // pin only where the moment fits and motion is on, decided again whenever the window changes size, as on Agent
    // Apps: the small viewport is read (100svh, what the pin is sized by), and pinning needs 40px more than unpinning
    var probe = document.createElement('div');
    probe.setAttribute('aria-hidden', 'true');
    probe.style.cssText = 'position:fixed;left:0;top:0;width:0;height:100vh;height:100svh;visibility:hidden;pointer-events:none';
    document.body.appendChild(probe);
    var fits = function (need) { return (probe.offsetHeight || window.innerHeight) - MO.head() >= need; };
    var played = false;
    function playOnce() {
      // too short to pin: the store builds itself once, when it comes into view
      show(1); progress(1 / n);
      MO.when(scene, 0.7, function () {
        if (pinned || played) return;
        played = true;
        for (var b = 2; b <= n; b++) {
          (function (k) { timers.push(later(function () { if (!pinned && MO.live) { show(k); progress(k / n); } }, 0.9 * (k - 1))); })(b);
        }
      });
    }
    function pinOn() {
      pinned = true;
      stop();
      sec.classList.add('sv-on');
      cur = -1; show(1); progress(0);
      if (!sc) sc = MO.scene(track, pin, function (p) { if (!pinned) return; progress(p); show(Math.min(n, 1 + Math.floor(p * n * 0.999))); });
      else MO.remeasure();
    }
    function pinOff() {
      pinned = false;
      sec.classList.remove('sv-on');
      finish();
      MO.remeasure();
    }
    function decide() {
      raf = 0;
      if (MO.live && !pinned && fits(560)) pinOn();
      else if (pinned && !(MO.live && fits(520))) pinOff();
    }
    function soon() { if (!raf) raf = requestAnimationFrame(decide); }
    // while the page loads the first answer reads no layout (MO.tall); the next frame checks it against the small
    // viewport, after the kit has measured the page once (#81)
    if (!MO.live) finish();
    else if (MO.tall(520)) pinOn();
    else playOnce();
    if (MO.live) requestAnimationFrame(function () { if (!MO.live) return; if (!pinned && fits(520)) pinOn(); else if (pinned && !fits(520)) { pinOff(); playOnce(); } });
    addEventListener('resize', soon);
    addEventListener('orientationchange', soon);
    // the Pause animations button: paused, the moment is unpinned on its finished store, kept in view when the
    // visitor was inside it; played again, it pins where it fits
    onMotion(function () {
      if (MO.live) { if (!pinned && fits(520)) pinOn(); return; }
      if (!pinned) { finish(); return; }
      var r = track.getBoundingClientRect(), inside = r.top <= MO.head() + 1 && r.bottom >= window.innerHeight;
      pinOff();
      if (inside) {
        var stage = sec.querySelector('.sv-stage');
        window.scrollTo(0, Math.round(stage.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - MO.head() - 16));
      }
    });
  }

  // ---- (3) a week with us: the days land one by one, each Approved once
  function week(sec) {
    var card = sec.querySelector('.sv-wk');
    if (!card) return;
    var oks = all(card, '.mo-ok'), timers = [];
    function finish() { timers.forEach(clearTimeout); timers = []; card.classList.add('on'); on(oks); }
    onMotion(finish);
    if (!MO.live) { finish(); return; }
    oks.forEach(function (el) { el.classList.remove('on'); });
    MO.when(card, 0.75, function () {
      card.classList.add('on');
      oks.forEach(function (ok, i) { timers.push(later(function () { ok.classList.add('on'); }, 0.45 + i * 0.28)); });
    });
  }

  // ---- (4) the proof: each number settles once, from a little below to the number the Results page shows
  function proof(sec) {
    var nums = all(sec, '.sv-num').filter(function (el) { return /^[\d,]+$/.test(el.getAttribute('data-to') || ''); });
    if (!nums.length) return;
    function finish() { nums.forEach(function (el) { el.textContent = el.getAttribute('data-to'); }); }
    onMotion(function () { if (!MO.live) finish(); });
    if (!MO.live) return;
    var fmt = function (v) { return Math.round(v).toLocaleString('en-US'); };
    var ends = nums.map(function (el) { return +el.getAttribute('data-to').replace(/,/g, ''); });
    nums.forEach(function (el, i) { el.textContent = fmt(ends[i] * 0.86); });
    MO.when(sec, 0.7, function () {
      MO.anim(1.1, function (p) {
        var e = MO.ease.out(p);
        nums.forEach(function (el, i) { el.textContent = p >= 1 ? el.getAttribute('data-to') : fmt(ends[i] * (0.86 + 0.14 * e)); });
      });
    });
  }

  all(PAGE, '.sv-open').forEach(opening);
  all(PAGE, '.sv-build').forEach(function (sec) { glowIn(sec); build(sec); });
  all(PAGE, '.sv-week').forEach(function (sec) { glowIn(sec); week(sec); });
  all(PAGE, '.sv-proof').forEach(proof);
})();
